import React, { Component } from "react";
import FullScreen from "../../../components/UI/FullScreen/FullScreen";
import { CheckValue, getAvailableUser } from "../../../services/CommonFunction";
import { Header } from "../Header/Header";
import StreamMember from "../StreamMember/StreamMember";
import {
  BoardContainerOngoingRoom,
  CenterCoachProfile,
  FooterOngoing,
  PinVideoView,
  PinVideoViewZoom,
} from "../ChildComponentUI/ChildComponentUI";
import "./Ongoing.scss";
import { changeVolume } from "../../../components/UI/InputRange/InputRange";
// import IVS from "../IVS/IVS";
import PlayStream from "../../Casting/MemberStream/MemberStream";
import { setStartStream } from "../SocketFun";
import { staticVar } from "../../../services/Constants";
import { ErrorUI } from "../../../components/UI/Modals/Modals";
// import ZoomSDK from '../ZoomSDK/ZoomSDK';

class Ongoing extends Component {
  constructor(props) {
    super(props);
    this.chatRef = React.createRef();
    this.streamRef = React.createRef();
    // this.zoomRef = React.createRef();
    this.state = {
      showSeekBar: false,
      firstTime: false,
      value: 100,
      liveLatency: 0,
      id: "video-player",
    };
  }

  get video() {
    return document.getElementById(this.state.id);
  }

  componentDidMount() {
    console.log(
      "Ongoing mounted==",
      localStorage.getItem("reload"),
      localStorage.getItem("firstTime")
    );

    if (localStorage.getItem("reload") || localStorage.getItem("firstTime")) {
      // localStorage.removeItem('reload');
      localStorage.setItem("reload", true);
      localStorage.removeItem("firstTime");
    } else {
      localStorage.setItem("reload", true);
    }
    this.setState({
      showSeekBar: true,
    });
    if (CheckValue(localStorage.getItem("setVolume"))) {
      changeVolume(
        parseInt(localStorage.getItem("setVolume"), 10),
        this.state.id,
        "null"
      );
    } else {
      changeVolume(100, this.state.id, "null");
    }
    const {
      allUsers,
      tagUsers,
      zoom,
      low_latency_mode,
      mute_participants_by_default,
    } = this.props;
    const { allUsersArr } = getAvailableUser(allUsers, "all");
    const currentUser = allUsersArr.find((item) => item.me);
    if (low_latency_mode && CheckValue(currentUser)) {
      currentUser.showStream = true;
      if (CheckValue(zoom) && CheckValue(zoom.getLocalVideoStatus())) {
        currentUser["stream"] = zoom.getLocalVideoStatus();
      }
      tagUsers.push(currentUser);
      if (CheckValue(zoom) && mute_participants_by_default) {
        zoom.muteByDeault();
      }
    }
  }

  componentWillUnmount() {}

  toggleBox = (type) => {
    this.setState((prevState) => ({
      toggleDiv: {
        ...prevState.toggleDiv,
        [type]: !prevState.toggleDiv[type],
      },
    }));
  };

  chatToggle = () => {
    this.setState((prevState) => ({
      chatUxToggle: !prevState.chatUxToggle,
    }));
  };

  stateSet = (obj) => {
    this.setState(obj);
  };

  get streamRefs() {
    return this.streamRef.current;
  }
  get streamRefData() {
    if (this.streamRefs) {
      return this.streamRefs.getStreamData;
    } else {
      return {
        constraints: { video: { width: 1280, height: 720, deviceId: "" } },
        isCameraEnabled: false,
        videoId: "memberVideo",
        webRTCAdaptor: null,
      };
    }
  }

  render() {
    const { showSeekBar, value, id, liveLatency } = this.state;
    const {
      canvas,
      webPreviewOff,
      totalSeconds,
      allUsers,
      tagUsers,
      required,
      userActivityData,
      workoutData,
      coachData,
      socket,
      gymData,
      selfData,
      startStream,
      ongoing,
      userPin,
      memberVideo,
      memberVideos,
      low_latency_mode,
      video_conference_data,
      activityStatus,
      stateSet,
      zoom,
      zoomData,
      mute_participants_by_default,
      leaveMeeting,
    } = this.props;

    const { allUsersArr } = getAvailableUser(allUsers, "all");
    const currentUserIndex = allUsersArr.findIndex((el) => el.me);
    let activeSpeakerText = null;
    if (
      zoomData.activeSpeaker &&
      allUsers.hasOwnProperty(zoomData.activeSpeaker.user_id)
    ) {
      if (allUsers[zoomData.activeSpeaker.user_id].me) {
        activeSpeakerText = "You are speaking...";
      } else {
        activeSpeakerText =
          allUsers[zoomData.activeSpeaker.user_id].first_name +
          " is speaking...";
      }
    }

    let pinUserVideo = [];
    let streamMember;
    if (low_latency_mode) {
      allUsersArr.forEach((obj1) => {
        tagUsers.forEach((obj2) => {
          if (obj2.user_id === obj1.user_id) {
            // obj1.stream = true;
            // obj1.isVideoStarted = false;
            pinUserVideo.push(obj1);
          }
        });
      });
    } else {
      pinUserVideo = tagUsers
        .filter((el) => el.showStream)
        .map((data) => {
          const el = allUsers[data.user_id];
          if (low_latency_mode) {
          } else {
            if (el.video_stream) {
              if (
                !CheckValue(el.stream) &&
                document.getElementById(el.user_id)
              ) {
                el.stream = PlayStream({ ...el }, () => setStartStream(el));
              }
            } else {
              if (CheckValue(el.stream)) {
                if (typeof el.stream !== "boolean") {
                  el.stream.stop(el.user_activity_session_id);
                  delete el.stream;
                }
              }
            }
          }
          return el;
        });
      streamMember = Object.keys(userActivityData).length ? (
        <StreamMember
          pushSocket={true}
          socket={socket}
          ref={memberVideo}
          userActivityData={userActivityData}
        />
      ) : null;
    }
    let coachVideoStatus = false;
    if (CheckValue(zoom)) {
      coachVideoStatus = zoom.getCoachVideoStatus();
    }
    return (
      <React.Fragment>
        {activeSpeakerText ? (
          <div className="showSpeaking">
            <div className="speaking">{activeSpeakerText}</div>
          </div>
        ) : (
          ""
        )}

        <section className="Casting background">
          {low_latency_mode ? (
            <PinVideoViewZoom
              zoomData={zoomData}
              {...this.props}
              pinUserVideos={pinUserVideo}
              zoom={zoom}
            />
          ) : (
            <PinVideoView
              pinUserVideo={pinUserVideo}
              required={required}
              streamMember={streamMember}
              memberVideos={memberVideos}
              low_latency_mode={low_latency_mode}
              zoom={low_latency_mode ? zoom : null}
            />
          )}
          <Header
            liveLatency={liveLatency}
            setData={(obj) => this.setState(obj)}
            coachData={coachData}
            ondemand={false}
            id={id}
            gymData={gymData}
            canvas={canvas}
            ongoing={ongoing}
            showSeekBar={showSeekBar}
            totalSeconds={totalSeconds < 0 ? 0 : totalSeconds}
            workoutData={workoutData}
            low_latency_mode={low_latency_mode}
          />
          <BoardContainerOngoingRoom
            {...this.props}
            userPin={userPin}
            chatRef={this.chatRef}
            required={required}
            activeSpeakerText={activeSpeakerText}
          />
          <FooterOngoing
            mute_participants_by_default={mute_participants_by_default}
            ondemand={false}
            id={id}
            value={value}
            required={required}
            selfData={selfData}
            rank={currentUserIndex + 1}
            memberVideos={memberVideos}
            low_latency_mode={low_latency_mode}
            zoom={low_latency_mode ? zoom : null}
            leaveMeeting={leaveMeeting}
          />
          <FullScreen />
        </section>
      </React.Fragment>
    );
  }
}

export default Ongoing;
